// extracted by mini-css-extract-plugin
export default {"productContainer":"TestProducts_productContainer__g7-7c","modeContainer":"TestProducts_modeContainer__1yxSj"};